import { render } from "./CardRow.vue?vue&type=template&id=0cf5346c&scoped=true"
import script from "./CardRow.vue?vue&type=script&lang=js"
export * from "./CardRow.vue?vue&type=script&lang=js"

import "./CardRow.vue?vue&type=style&index=0&id=0cf5346c&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf5346c"]])

export default __exports__